import clsx from "clsx";

function Checkbox({ state = "unchecked", onChange, disabled, "aria-label": ariaLabel, className }) {
  const on = state !== "unchecked";
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={state === "indeterminate" ? "mixed" : state === "checked"}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => !disabled && onChange?.()}
      className={clsx(
        "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded border text-surface",
        on ? "border-accent-solid bg-accent-solid" : "border-border bg-surface",
        disabled && "cursor-not-allowed opacity-50",
        className,
      )}>
      {state === "checked" && (
        <svg aria-hidden="true" viewBox="0 0 12 12" fill="none" className="h-3 w-3">
          <path d="M2.5 6.2 4.9 8.6 9.5 3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
      {state === "indeterminate" && <span aria-hidden="true" className="h-0.5 w-2.5 bg-surface" />}
    </button>
  );
}

export default Checkbox;
